// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> weidner-apartment-homes-weidner-classic-theme -> woodin-creek-village
// Generated: 2026-11-03T21:25:40.003Z
// Counts: 0 design, 24 content, 33 slot group, 2 collection binding, 10 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities &amp; Luxuries</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "header.company_name": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Interactive site map</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "luxurydefinition.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "neighborhoodmap.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>High-Rise Sophistication in the Heart of Downtown <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span>, we’re not just pet-friendly, we LOVE pets and show it by providing a fenced-in pet exercise area, always having treats in the office and hosting frequent Yappy Hours…</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "penthouse.featureList": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Granite countertops</li><li>Kitchen islands</li><li>Gas ranges</li><li>Energy Star certified appliances</li><li>Stainless steel, black, or white appliance finishes</li><li>Vaulted ceilings</li><li>Cozy fireplaces</li><li>Walk-in closets</li><li>Full-size in-home washer and dryer</li><li>Central AC and heating</li><li>Oversized penthouse decks and balconies</li><li>Walk-in pantry storage</li></ul>",
    "mappedField": null
  },
  "petpolicy.dogs_restrictions": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Pit Bull &amp; Pit Bull Mixes</li><li>American Pit Bull Terrier</li><li>American Staffordshire Terrier</li><li>Wolf Hybrids</li><li>Doberman Pinscher</li><li>Saint Bernard</li></ul><ul><li>American Bulldog</li><li>Staffordshire Bull Terrier</li><li>German Shepherd</li><li>Chow Chow</li><li>Great Dane</li><li>Akita</li></ul>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.qualifying_criteria_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/company/5726763346821120/01a0edf8-50e1-766e-be36-fe17d735f389.pdf"
      }
    }
  },
  "specialofferbanner.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "amenitieslist.apartmentPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-af9b-737f-a0f2-c4a0283d18dd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with stainless steel appliances, wood cabinets, granite countertops, and a central island."
      }
    }
  },
  "amenitieslist.apartmentPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-ab21-7199-a7d0-5581dd3ade3d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-size bed, nightstand, and walk-in closet."
      }
    }
  },
  "amenitieslist.apartmentPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-32ed-73a5-aaea-4fc2025a431a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bathroom with double vanity, soaking tub, and sleek fixtures."
      }
    }
  },
  "amenitieslist.apartmentPhoto4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-dc35-723b-9669-e349a71905d5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with fireplace and kitchen view"
      }
    }
  },
  "amenitieslist.communityPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bar area with seating and wine bottles on shelves"
      }
    }
  },
  "amenitieslist.communityPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-4cf3-730f-a908-297d58dfe9b0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern lobby with red chairs and fireplace."
      }
    }
  },
  "amenitieslist.communityPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-5aef-72aa-ac2e-73d8b625a40d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment building gym with treadmills, weight machines, and free weights."
      }
    }
  },
  "amenitieslist.communityPhoto4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-5455-7495-b446-bc6829bb3e4c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor lounge area with seating, umbrellas, and a grill station."
      }
    }
  },
  "contact-hero.bg_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 30,
    "fieldOverrides": null
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo_media.alt_text"
      }
    }
  },
  "frc-hero.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": ""
      },
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "interactive-map-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "luxurydefinition.propertygraphic": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-2d6b-734a-a151-2d4d9bc2aaae.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Woodin Creek Village mixed-use building with ground-floor tasting room and retail beneath apartment homes"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "penthouse.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-7d8a-706f-95bd-f398ff734b21.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior of a modern apartment unit with an open-concept kitchen and living room featuring a fireplace and large windows."
      }
    }
  },
  "penthouse.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-b6fc-77b8-84ec-f6728558da5a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with an island, stainless steel appliances, and white cabinets."
      }
    }
  },
  "penthouse.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-32ed-73a5-aaea-4fc2025a431a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bathroom with double vanity, soaking tub, and sleek fixtures."
      }
    }
  },
  "penthouse.photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-ab21-7199-a7d0-5581dd3ade3d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-size bed, nightstand, and walk-in closet."
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "petpolicy.cats_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A friendly cat resting comfortably indoors"
      }
    }
  },
  "petpolicy.dogs_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-00b0-7538-bb8a-ea005f2f19e0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resident walking two dogs along the Woodin Creek Village streetscape by outdoor dining"
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "winedinelogoslide.card1": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "winedinelogoslide.card5": {
    "sourceIndex": 10,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": [
      "ec_713e8da7ca5100e0c8055b77",
      "ec_231f44915f92f3faed6741d7",
      "ec_a1d7487e34f0e556f996933c",
      "ec_913732557661f57292e8f415",
      "ec_d31d600ad8f71eecb1973c53",
      "ec_942169a4365ef206fc510a0b",
      "ec_ca476caa355020971c688009",
      "ec_d35654143ed03afa7a406afd",
      "ec_925ace02c62eb2585cbef3ef",
      "ec_34aab96eb9b070a6de67f03b",
      "ec_0d11c30ab914f7a1dddeeb7b",
      "ec_958b6ee15ecb03cb21febe1b",
      "ec_e21548aa84a6167427f643eb",
      "ec_be4284c16f6b97d0e4b961c1",
      "ec_a98fdc6d4c9e330cd4bc9268"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "pinnedcallouts.amenities": {
    "limit": null,
    "hiddenIds": [
      "ec_b715e22a10535e4eeb4d2910",
      "ec_a1d7487e34f0e556f996933c",
      "ec_ca476caa355020971c688009",
      "ec_d35654143ed03afa7a406afd",
      "ec_925ace02c62eb2585cbef3ef",
      "ec_34aab96eb9b070a6de67f03b",
      "ec_0d11c30ab914f7a1dddeeb7b",
      "ec_942169a4365ef206fc510a0b",
      "ec_a98fdc6d4c9e330cd4bc9268",
      "ec_d31d600ad8f71eecb1973c53",
      "ec_913732557661f57292e8f415",
      "ec_958b6ee15ecb03cb21febe1b",
      "ec_e21548aa84a6167427f643eb",
      "ec_be4284c16f6b97d0e4b961c1"
    ],
    "orderedIds": [
      "ec_dcf924ac2a09a39098539f82",
      "ec_6834a3e33b18a97c9ef9e0fe",
      "ec_4e9dea47081c9dcf21e712d4",
      "ec_92552977e4cd781fce82e6f7",
      "ec_b715e22a10535e4eeb4d2910",
      "ec_c60cce001323cb4cd670071a",
      "ec_941db44cbf51325e2b51c060",
      "ec_4b165cabedfb0ae24a58f740",
      "ec_6bd31a0552eeb7e11f6511bf",
      "ec_c5af4c79232f8e3c0d0b3c02",
      "ec_6e40ab0bd5e63d6790bc9e81",
      "ec_2dc6c4ceab3951c91dcc3629",
      "ec_d229e711348ee4d56b899f0b",
      "ec_713e8da7ca5100e0c8055b77",
      "ec_231f44915f92f3faed6741d7",
      "ec_ffc2e99c0afcd885ea652d24",
      "ec_efcb4e1d64423f69d309f9bd",
      "ec_20934599271a69be19b77ae6",
      "ec_d7744d641633f658e05701cc",
      "ec_4f17373140bc447864ba7bd4",
      "ec_b74af3a5d1c741a43882ef8d",
      "ec_0cb5cccfea01befc60521dff",
      "ec_17973db6d42e71e6830d2641",
      "ec_2db532b6f67db5e361259c1b",
      "ec_d6e1a0a89f77b245d36f1052",
      "ec_53eb936732b62b13b89a1f86",
      "ec_c59097aa32791f125fe7ab71",
      "ec_351cc75d444c3607ec56f95b",
      "ec_9995b6bffe0426cfd79e9e6b",
      "ec_ef1659ae21eedbda9d513567",
      "ec_cbfa2b0a67362f9385206033",
      "ec_90901a1f3d39c1fa15202288",
      "ec_a1d7487e34f0e556f996933c",
      "ec_66cb49128cf795842149aabc",
      "ec_adbd81f85a2f5eb1b6af00a8",
      "ec_958b6ee15ecb03cb21febe1b",
      "ec_913732557661f57292e8f415",
      "ec_d31d600ad8f71eecb1973c53",
      "ec_942169a4365ef206fc510a0b",
      "ec_a98fdc6d4c9e330cd4bc9268",
      "ec_ca476caa355020971c688009",
      "ec_d35654143ed03afa7a406afd",
      "ec_925ace02c62eb2585cbef3ef",
      "ec_34aab96eb9b070a6de67f03b",
      "ec_0d11c30ab914f7a1dddeeb7b",
      "ec_e21548aa84a6167427f643eb",
      "ec_be4284c16f6b97d0e4b961c1"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "interactive-leasing-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 10
    }
  ]
};

export const styleOverrides = {};
